import { axiosInstance } from "../axios";

export const comboItemApi = {
  getAll: async () => {
    return await axiosInstance.get("/combo-items");
  },
  getPaginate: (params) =>
    axiosInstance.get("/combo-items/paginate", { params }),
  getById: async (id) => {
    return await axiosInstance.get(`/combo-items/${id}`);
  },
  create: async (body) => {
    return await axiosInstance.post("/combo-items", body);
  },
  update: async (id, body) => {
    return await axiosInstance.put(`/combo-items/${id}`, body);
  },
  remove: async (id) => {
    return await axiosInstance.delete(`/combo-items/${id}`);
  },
};
